import Button from "Components/Common/Button/Button";
import React from "react";

interface SubmitBarProps {
  count: number;
  total: number;
  onSaveReturn: () => void;
  onSubmit: () => void;
  disabled?: boolean;
  isSaving?: boolean;
}

const SubmitBar = ({
  count,
  total,
  onSaveReturn,
  onSubmit,
  disabled,
  isSaving,
}: SubmitBarProps) => (
  <div className="submitBar">
    <div className="submitBar__info">
      <span>
        {count} / {total}
      </span>{" "}
      requirements acknowledged
    </div>
    <div className="submitBar__actions">
      <Button
        className="submitBar__saveBtn"
        type="button"
        onClick={onSaveReturn}
        disabled={isSaving}
      >
        {isSaving ? (
          <>
            <span className="submitBar__spinner" /> Saving…
          </>
        ) : (
          "Save & Return"
        )}
      </Button>
      <Button
        className="submitBar__submitBtn"
        type="button"
        onClick={onSubmit}
        disabled={disabled || isSaving}
      >
        <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
          <path
            d="M2 7.5l4 4 7-7"
            stroke="#fff"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        Submit Acknowledgment
      </Button>
    </div>
  </div>
);

export default SubmitBar;
